import logo from 'assets/images/logo.png';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Column, Row } from 'shared';

import { HeaderContent, HeaderFixed, HeaderTools, HeaderWrapper, Logo } from './Header.styles';
import { HeaderProps } from './Header.types';
import { HeaderNav } from './headerNav/HeaderNav';
import { HeaderNavToggle } from './headerNavToggle/HeaderNavToggle';
import { TopLine } from './headerTopLine/HeaderTopLine.styles';

export const Header = ({ active, links, children, title, className }: HeaderProps) => {
  const [isMobileOpened, setMobileOpened] = useState(false);

  const handleMobileOpened = () => {
    setMobileOpened(mobileOpened => !mobileOpened);
  };

  const handleCloseMobile = () => {
    setMobileOpened(false);
  };

  return (
    <HeaderWrapper className={`header ${className || ''}`}>
      <HeaderFixed className={`header__container ${isMobileOpened ? 'header__container--opened' : ''}`}>
        <Row>
          <Column size={[12]}>
            <TopLine />
          </Column>
        </Row>

        <Row>
          <Column mx={[0, 0, 2]} my={[0, 0, 2]}>
            <HeaderContent className="header__content">
              <HeaderNavToggle opened={isMobileOpened} onClick={handleMobileOpened} />
              <Link to="/" onClick={handleCloseMobile}>
                <Logo src={logo} alt="mBank" className="header__logo" />
              </Link>
              {!!title && title}
              <HeaderNav links={links} active={active} onClickLink={handleCloseMobile} />
              <HeaderTools className="header__tools">{children && children({ handleCloseMobile })}</HeaderTools>
            </HeaderContent>
          </Column>
        </Row>
      </HeaderFixed>
    </HeaderWrapper>
  );
};
